import { TypeOf, yup } from '@guiker/yup-util'

export const consentBackgroundCheckPayloadValidator = yup.object({
  consent: yup.boolean().required(),
})

export type ConsentBackgroundCheckPayload = TypeOf<typeof consentBackgroundCheckPayloadValidator>
